import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getAccount } from '@/api';
import { openPrematchStatistics } from '@/domain/prematch-statistics';
import { requestPrematchStatistics } from '@/ui/sports/prematch-statistics-bus';

/** Same cutoff as legacy `SportsApp.IsMobile` (`width < 1024`) and Tailwind `lg`. */
const MOBILE_MQ = '(max-width: 1023px)';

function readIsMobile(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_MQ).matches;
}

/**
 * Prematch stats icon handler — FeedType-branched like legacy
 * `SportsApp.Tools.Statistics`.
 */
export function usePrematchStatistics() {
  const { t, i18n } = useTranslation();

  const showStats = useCallback(
    (eventId: number) => {
      const account = getAccount();
      const language = i18n.resolvedLanguage ?? i18n.language;
      const result = openPrematchStatistics({
        eventId,
        feedType: account?.FeedType,
        language,
        isMobile: readIsMobile(),
      });

      if (result.kind === 'opened') return;

      if (result.kind === 'blocked') {
        requestPrematchStatistics({
          kind: 'toast',
          message: t('PleaseDisablePopupBlocker', {
            defaultValue: 'Please disable the popup blocker',
          }),
        });
        return;
      }

      requestPrematchStatistics(result);
    },
    [i18n.language, i18n.resolvedLanguage, t],
  );

  return { showStats };
}
